import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import { clearPostLoginReturnTo, isRestorableReturnPath } from '../brandSupportDeepLink';

const AuthCallback = () => {
  const navigate = useNavigate();
  const handledRef = useRef(false);

  useEffect(() => {
    // Auth0: handleRedirectCallback must run exactly once per code/state.
    // Re-entry removes the transaction and yields missing_transaction loops.
    if (handledRef.current) return undefined;
    handledRef.current = true;

    const handleCallback = async () => {
      try {
        const result = await authService.handleRedirectCallback();
        // Resume only the deep link carried by THIS login attempt (Support
        // email → exact Case); never a tab-level leftover from an abandoned
        // attempt. Otherwise the canonical post-login bootstrap.
        clearPostLoginReturnTo();
        const returnTo =
          result.success && isRestorableReturnPath(result.returnTo)
            ? result.returnTo
            : null;
        navigate(result.success ? returnTo || '/app' : '/signin', { replace: true });
      } catch (error) {
        console.error('Callback auth failed:', error);
        navigate('/signin', { replace: true });
      }
    };

    handleCallback();
    return undefined;
  }, [navigate]);

  return <div>Authenticating...</div>;
};

export default AuthCallback;
